import TrialVipsApp from './TrialVipsApp';
import React from 'react';
import {Redirect} from 'react-router-dom';
import {authRoles} from "../../../../store/actionreducers/auth/auth";

export const TrialVipsAppConfig = {
    settings: {
        layout: {
            config: {
                footer : {
                    display: false
                }
            }
        }
    },
    auth: authRoles.sales,//  ['sales']
    routes: [
        {
            path: '/apps/trialVip/:id',
            component: TrialVipsApp
        },
        {
            path: '/apps/trialVip',
            component: () => <Redirect to="/apps/trialVip/all"/>
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/sales/trial_vip/TrialVipsAppConfig.js